var map = {
	"./43_banana.mp3": "b1bb",
	"./44_pear.mp3": "8051",
	"./45_cherry.mp3": "ecdd",
	"./46_lemon.mp3": "9b29",
	"./47_pepper.mp3": "5649",
	"./48_carrot.mp3": "065f",
	"./49_tomato.mp3": "eb3e",
	"./50_dog.mp3": "3cbf",
	"./51_cat.mp3": "9446",
	"./52_mouse.mp3": "44b5",
	"./53_fish.mp3": "1db6",
	"./54_hamster.mp3": "9f8d",
	"./55_parrot.mp3": "e0aa",
	"./56_canary.mp3": "c8a6",
	"./M_Brilliant.mp3": "66dc",
	"./M_Excellent.mp3": "8e36",
	"./M_Fantastic.mp3": "4bd2",
	"./M_Great.mp3": "73dc",
	"./M_Perfect.mp3": "6392",
	"./M_Think again.mp3": "bed0",
	"./M_Try again.mp3": "7654",
	"./M_Very good.mp3": "e5c5",
	"./M_Well done.mp3": "d315",
	"./M_Work harder.mp3": "ef45",
	"./click.mp3": "7330",
	"./false.mp3": "3371"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e4cbb";